import React, {useState, useEffect, useContext} from 'react';
import 'index.css';
import './Paiement.scss';
import axios from 'axios';
import Conf from 'utils/Conf';

import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import {withTranslation} from 'react-i18next';
import Context from 'utils/Context';

import Pager from 'components/Pager';
import PaiementChoices from './PaiementChoices';
import PaiementWait from './PaiementWait';
import PaiementOk from './PaiementOk';
import PaiementKo from './PaiementKo';
import PaiementErreur from './PaiementErreur';
import PaiementDenied from './PaiementDenied';
import PaiementHorsZone from './PaiementHorsZone';

const Paiement = ({t, keepOpen, open, seance, onSuccess, onClose, container, status}) => {
  const {appState, methods, goTo} = useContext(Context);
  const [idx, setIdx] = useState(0);
  const [erreur, setErreur] = useState('');
  const [paid, setPaid] = useState(false);
  const [amount, setAmount] = useState(0);
  const [shouldOpen, setShouldOpen] = useState(false);
  const [seanceWait, setSeanceWait] = useState(null);
  const [choice, setChoice] = useState(null);

  const handlePaymentMethodChoice = paymentMethodName => {
    setChoice(paymentMethodName);
    localStorage.setItem('paymentMethod', paymentMethodName);
  };

  useEffect(() => {
    if (appState.query) {
      if (
        appState.query.id_seance &&
        appState.query.payment_intent &&
        appState.query.redirect_status &&
        appState.query.payment_intent_client_secret
      ) {
        // stripe paymentIntent pending go to wait
        setShouldOpen(true);
        setSeanceWait({seance_id: appState.query.id_seance});
        let newQuery = {...appState.query};
        delete newQuery.id_seance;
        delete newQuery.payment_intent;
        delete newQuery.redirect_status;
        delete newQuery.payment_intent_client_secret;
        delete newQuery.source_type;
        if (appState.query.redirect_status === 'failed') go(8);
        else go(7);
        methods.setAppState({query: newQuery});
      }
      //TODO: Temporary fix for postfinance payment !
      if (appState.query.waitingPaymentConfirmation === 'postfinance') {
        const seanceID = localStorage.getItem('seance_id');
        setSeanceWait({seance_id: seanceID});
        setShouldOpen(true);
        if (appState.query.paymentError) go(8);
        else go(7);
        localStorage.removeItem('seance_id');
      }
    }
  }, [appState.query, methods]);

  const go = idx => {
    setIdx(idx);
  };

  const handleEnter = () => {
    if (seance && !shouldOpen) {
      if (!appState.user.email) {
        handleErreur(t('vous-netes-pas-connecte'));
      } else if (status) {
        if (status === 'failed') {
          handleErreur(t('le-paiement-a-echoue'));
        }
        if (status === 'success') {
          go(2);
        }
      } else if (!seance.local) {
        go(6);
      } else {
        setIdx(0);
        setPaid(false);
        getInfos();
      }
    }
  };

  const handleErreur = erreur => {
    setErreur(erreur);
    go(4);
  };

  const handleDenied = () => {
    go(5);
  };

  const handleOk = (wait = false) => {
    setPaid(true);
    if (wait) {
      go(9);
    } else {
      go(3);
    }
    methods.getProfile();
    if (onSuccess) onSuccess();
  };

  const handleKo = () => {
    go(8);
  };

  const onCloseHandler = () => {
    if (!keepOpen) {
      setIdx(0);
      setErreur('');
      setPaid(false);
      setShouldOpen(false);
      setSeanceWait(null);
      if (onClose) onClose();
    }
  };

  const onShouldClose = () => {
    setShouldOpen(false);
  };

  /* Check if user is connected on an unique app instance */
  const getInfos = () => {
    axios
      .get(Conf.apiBaseUriLegacy + '/user/paiement/' + seance.seance_id, {
        params: {
          uuid: appState.uuid,
        },
        withCredentials: true,
      })
      .then(res => {
        if (res.data.status === 'error') {
          go(5);
        } else {
          localStorage.setItem('seance_id', seance.seance_id);
          if (res.data.authorized === true || '') {
            handleOk(true);
          } else if (res.data.authorized === false) {
            setAmount(res.data.amount);
            go(1);
          } else {
            handleErreur(t('quelque-chose-s-est-mal-passe-merci-d-essayer-plus-tard'));
          }
        }
      })
      .catch(() => {
        handleErreur(t('probleme-de-connexion-merci-dessayer-plus-tard'));
      });
  };

  /* Listing of paiement process */
  const pages = [
    <DialogContent>
      <DialogContentText>{t('chargement')}</DialogContentText>
      <div className="spacer" />
      <div className="spacer" />
      <CircularProgress size="100px" />
      <div className="spacer" />
      <div className="spacer" />
    </DialogContent>,
    <PaiementChoices
      seance={seance}
      amount={amount}
      onClose={onCloseHandler}
      onOk={handleOk}
      go={go}
      keepOpen={keepOpen}
      conf={appState.conf}
      appState={appState}
      email={appState.user.email}
      onErreur={handleErreur}
      onPaymentMethodChoice={handlePaymentMethodChoice}
    />,
    <PaiementWait
      seance={seance}
      paymentMethod={choice}
      onClose={onCloseHandler}
      go={go}
      onOk={handleOk}
      onErreur={handleErreur}
      appState={appState}
    />,
    <PaiementOk onClose={onCloseHandler} goToSeance={() => goTo('/seance/' + seance.seance_id)} />,
    <PaiementErreur erreur={erreur} onClose={onCloseHandler} go={go} />,
    <PaiementDenied seance={seance} onClose={onCloseHandler} go={go} />,
    <PaiementHorsZone onClose={onCloseHandler} go={go} />,
    <PaiementWait
      seance={seanceWait}
      paymentMethod={choice}
      onClose={onCloseHandler}
      go={go}
      onOk={() => handleOk(true)}
      onKo={handleKo}
      onErreur={handleErreur}
      appState={appState}
    />,
    <PaiementKo onClose={onShouldClose} />,
    <PaiementOk onClose={onCloseHandler} goToSeance={() => goTo('/seance/' + seanceWait.seance_id)} />,
  ];

  return (
    <Dialog
      open={open || shouldOpen}
      onClose={onCloseHandler}
      TransitionProps={{onEnter: handleEnter}}
      scroll="body"
      className="my-dialog"
      container={container || null}
    >
      <Pager pages={pages} idx={idx} />
    </Dialog>
  );
};

export default withTranslation()(Paiement);
